/**
 * @summary
 * <blockquote>Permission verbs mapped to their string values</blockquote>
 **/
import { permissionOrder } from '../functions/permissionOrder';

export const PERMISSION_VERBS = {
  CREATE: permissionOrder[0],
  READ: permissionOrder[1],
  UPDATE: permissionOrder[2],
  DELETE: permissionOrder[3],
  MANAGE: permissionOrder[4],
  APPROVE: permissionOrder[5],
  REJECT: permissionOrder[6],
  EXPORT: permissionOrder[7],
  IMPORT: permissionOrder[8],
} as const; 